module.exports = __webpack_public_path__ + "static/seo-bg-4eaf37f00e601323166e63a8caf8caf6.jpg";